<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="44"
				:view-config="saasInfo.viewmanage"
				selector
			>
				<template #search>
					<!--调拨方向（我调出的/调拨给我的）不做硬编码页签，由视图配置的过滤字段（direction）生成视图页签-->
					<m-search ref="search">
						<m-search-item label="调拨单号">
							<c-input name="transfer_code" placeholder="请输入调拨单号"></c-input>
						</m-search-item>
						<m-search-item label="对方商户">
							<c-input name="merchant_name" placeholder="请输入对方商户名称"></c-input>
						</m-search-item>
						<m-search-item label="调拨状态">
							<c-select name="transfer_state" :options="PROFIT_TRANSFER_STATE" placeholder="全部"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_profit_transfer_create')" color="main" prepend-icon="tf-add" @click="createTransfer">创建分润调拨</c-button>
					<c-button v-if="auth('b_profit_transfer_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #transfer_state="{data}">
					<c-state dict="PROFIT_TRANSFER_STATE" tag :value="data.transfer_state"></c-state>
				</template>

				<template #transfer_ratio="{data}">
					{{data.transfer_ratio}}%
				</template>

				<template #receive_qty="{data}">
					<!--多轮接收：已接收数大于0即展示，不再等关单-->
					<span v-if="data.receive_qty > 0" style="color:orange;">{{data.receive_qty}}</span>
					<span v-else>-</span>
				</template>

				<template #pending_qty="{data}">
					<span v-if="data.transfer_state == 1" style="color:orange;">{{data.pending_qty}}</span>
					<span v-else>-</span>
				</template>

				<template #diff_qty="{data}">
					<!--与驳回数量互斥：存在驳回时差异含驳回件数，同屏展示会重复计数误导，故让位显示-->
					<span v-if="data.reject_qty > 0">-</span>
					<span v-else-if="data.diff_qty > 0" :style="data.transfer_state == 2 ? 'color:red;' : 'color:orange;'">{{data.diff_qty}}</span>
					<span v-else>-</span>
				</template>

				<template #reject_qty="{data}">
					<!--驳回数量=驳回中+已驳回，大于0红色提示-->
					<span v-if="data.reject_qty > 0" style="color:red;">{{data.reject_qty}}</span>
					<span v-else>-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="180"
					button-limit="6"
				>
					<template #default="{data}">
						<!--方向以行数据 direction 判断（后端按当前商户视角计算），不再依赖页面页签-->
						<c-table-button icon="tf-detail" @click="viewDetail(data)">查看</c-table-button>
						<!-- 调出侧 -->
						<c-table-button v-if="data.direction == 1 && auth('b_profit_transfer_edit') && data.transfer_state == 1 && userInfo.id == data.create_user_id" icon="tf-edit" @click="editTransfer(data)">编辑</c-table-button>
						<c-table-button v-if="data.direction == 1 && auth('b_profit_transfer_print')" icon="tf-print" @click="printTransfer(data)">打印调拨单</c-table-button>
						<c-table-button v-if="data.direction == 1 && auth('b_profit_transfer_delete') && data.transfer_state == 1 && userInfo.id == data.create_user_id" icon="tf-trash" color="red" @click="deleteTransfer(data)">删除</c-table-button>
						<!-- 调入侧 -->
						<c-table-button v-if="data.direction == 2 && auth('b_profit_transfer_receive') && data.transfer_state == 1 && data.pending_qty > 0" icon="tf-stock" color="main" @click="receiveTransfer(data)">调拨接收</c-table-button>
						<c-table-button v-if="data.direction == 2 && auth('b_profit_transfer_receive') && data.transfer_state == 1 && data.pending_qty > 0" icon="tf-reject" color="red" @click="rejectTransfer(data)">驳回</c-table-button>
						<!-- 调出侧：驳回中明细待调拨方确认回库 -->
						<c-table-button v-if="data.direction == 1 && auth('b_profit_transfer_edit') && data.transfer_state == 1 && data.rejecting_qty > 0" icon="tf-approve" color="main" @click="rejectConfirmTransfer(data)">驳回确认</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!--创建/编辑分润调拨弹窗-->
			<profit-transfer-edit ref="edit" @resolve="$refs.view.update()"></profit-transfer-edit>
			<!--调拨详情抽屉-->
			<profit-transfer-detail ref="detail" @resolve="$refs.view.update()"></profit-transfer-detail>
			<!--调拨接收弹窗-->
			<profit-transfer-receive ref="receive" @resolve="$refs.view.update()"></profit-transfer-receive>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import {asyncMapState} from '@/store'
	import profitTransferEdit from "@/pages/storage/profit_transfer_edit.vue";
	import profitTransferDetail from "@/pages/storage/profit_transfer_detail.vue";
	import profitTransferReceive from "@/pages/storage/profit_transfer_receive.vue";

	export default {
		name: 'm_profit_transfer',

		components: {profitTransferEdit, profitTransferDetail, profitTransferReceive},

		computed: {
			...mapState(['saasInfo', 'userInfo']),

			...asyncMapState(['PROFIT_TRANSFER_STATE'])
		},

		methods: {
			/********创建分润调拨************/
			createTransfer() {
				this.$refs.edit.open();
			},

			/********编辑分润调拨************/
			editTransfer(data) {
				this.$refs.edit.open(data);
			},

			/********查看调拨详情（方向由详情接口按当前商户视角返回）************/
			viewDetail(data) {
				this.$refs.detail.open(data.id);
			},

			/********调拨接收************/
			receiveTransfer(data) {
				this.$refs.receive.open(data.id);
			},

			/********打印调拨单（内置HTML模板打印，同线下订单链路）************/
			printTransfer(data) {
				this.$refs.view.batchPrintByTemplate([data.id]);
			},

			/********删除分润调拨************/
			deleteTransfer(data) {
				this.$confirm({
					message: '确认删除调拨单【' + data.transfer_code + '】？删除后条码将退回在库，不可恢复！',
					buttonName: '确定删除',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransfer/delete',
							data: {id: data.id},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '删除成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/********驳回（调入侧：一次性全量驳回未接收商品）************/
			rejectTransfer(data) {
				this.$confirm({
					message: '将全量驳回调拨单【' + data.transfer_code + '】全部【' + data.pending_qty + '】件未接收商品？驳回后待调拨方确认回库，不可撤销！',
					buttonName: '确定驳回',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransfer/reject',
							data: {id: data.id},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '驳回成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/********驳回确认（调出侧：驳回中商品回滚在库）************/
			rejectConfirmTransfer(data) {
				this.$confirm({
					message: '确认驳回调拨单【' + data.transfer_code + '】的【' + data.rejecting_qty + '】件商品？确认后商品回滚在库，不可撤销！',
					buttonName: '确认',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransfer/reject/confirm',
							data: {id: data.id},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '驳回确认成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>
